import { useEffect, useState } from 'react';
import {
  AccionDetalle,
  IInitialState,
  TipoAccionDetalle,
} from '../../Shared/data/FormReducer';
import Form01 from '../Forms/Form01';
import Form02 from '../Forms/Form02';
import Form03 from '../Forms/Form03';
import Form04 from '../Forms/Form04';
import Form05 from '../Forms/Form05';
import Form06 from '../Forms/Form06';
import SubirFotos from '../../Pages/SubirFotos/SubirFotos';
import toast from 'react-hot-toast';
import { sendFormUsuario } from '../../Services/Form';
import { useNavigate } from 'react-router-dom';
import LoadingAllScreen from '../LoadingAllScreen/LoadingAllScreen';
import { Tr4inerContainedButton } from '../../Utils/Button';
import { IUserFromStorage, ObjetivoUser } from '../../Interfaces/IUser';
import UploadVideo from '../../Pages/UploadVideo/UploadVideo';
// import Resultados from './Resultados';

interface IMainForm {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
}

const MainForm = ({ state, dispatch }: IMainForm) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [imgBase64Data, setImgBase64Data] = useState<string[]>([]);
  const [files, setFiles] = useState<any[]>([]);

  const user: IUserFromStorage = JSON.parse(localStorage.getItem('user'));

  const navigate = useNavigate();

  useEffect(() => {
    JSON.stringify(localStorage.setItem('state', JSON.stringify(state)));
    localStorage.setItem('sexoUser', true.toString());
  }, []);

  const disabledButton = () => {
    if (user.esReto) {
      if (files.filter((e: any) => e.valid === true).length < 4) {
        return true;
      } else {
        return false;
      }
    } else {
      if (files.filter((e: any) => e.valid === true).length < 3) {
        return true;
      } else {
        return false;
      }
    }
  };

  const continuar = () => {
    if (files.filter((e: any) => e.valid === true).length < 3) {
      return toast.error('Tienen que ser mínimo 3 imágenes 😢.');
    }
    dispatch({
      type: TipoAccionDetalle.CHANGE_FOTOS,
      payload: imgBase64Data,
    });
    window.scrollTo(0, 0);
    pasarAFinal();
  };

  const pasarAFinal = () => {
    setLoading(true);
    const date = new Date(Date.parse(state.edad));
    const FFormateada = `${date.getFullYear()}-${date.getMonth() + 1 < 10 ? '0' : ''}${
      date.getMonth() + 1
    }-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;

    try {
      let estaturaPiesToCm = Number(`${state.estatura}.${state.pulgadas}`) * 30.48;
      sendFormUsuario({
        UsuarioTestASesoriaID: state.usuarioTestAsesoriaID,
        Sexo: state.sexo,
        Objetivo: state.objetivo,
        FechaNacimiento: FFormateada,
        EstaturaReal:
          state.unidadEstatura === 'pi' ? estaturaPiesToCm : Number(state.estatura),
        UnidadEstatura: state.unidadEstatura,
        Peso: state.peso,
        PrioridadDias: state.vecesPorSemana === 5 ? 0 : state.diasPrioridad,
        UnidadPeso: state.unidadPeso,
        CantidadDias: state.vecesPorSemana,
        CantidadComidas: state.cantidadComidas,
        Suplementos: state.suplementos === '1' ? true : false,
        SedeID: state.dondeEntrenas,
        TipoActividad: state.tipoActividad,
        PorcentajeGrasa: state.porcentajeGrasa,
        TiempoRutina: state.tiempoRutinaDiaria,
        fotos: imgBase64Data,
      }).finally(() => {
        let user : IUserFromStorage = JSON.parse(localStorage.getItem('user'));
        user.respondio = true;
        user.objetivo = state.objetivo as ObjetivoUser;
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('state', JSON.stringify(state));
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(false);
        if(user.esReto) {
          navigate('/uploadVideo'); 
          // console.log('Es reto');
        } else {
          navigate('/despuesTest');
          // console.log('NO Es reto');
        }
      });
    } catch (error) {
      toast.error(`Ocurrió un problema, contáctese con nuestros asesores. ${error}`);
    }
  };

  // function pruebaDeFuego() {
  //   setLoading(true);
  //   setTimeout(() => {
  //     console.log(imgBase64Data);
  //     console.log(state);
  //     toast.success('Datos enviados correctamente.');
  //     setLoading(false);
  //     // setIsOpen(false);
  //   }, 3000);
  // }

  const previousform = () => {
    dispatch({
      type: TipoAccionDetalle.CHANGE_NFORM,
      payload: state.nForm - 1,
    });
  };

  return (
    <div className="mt-3 mb-14 w-full h-full">
      {/* <button
        onClick={previousform}
        type="button"
        className="absolute bottom-10 left-10 cursor-pointer"
      >
        dev
      </button> */}
      {loading && (
        <div className="absolute bg-slate-500/30 top-0 w-full min-h-[100dvh]">
          <LoadingAllScreen />
        </div>
      )}
      {state.nForm === 0 && <Form01 state={state} dispatch={dispatch} />}
      {state.nForm === 1 && <Form02 state={state} dispatch={dispatch} />}
      {state.nForm === 2 && <Form03 state={state} dispatch={dispatch} />}
      {state.nForm === 3 && <Form04 state={state} dispatch={dispatch} />}
      {state.nForm === 4 && <Form05 state={state} dispatch={dispatch} />}
      {state.nForm === 5 && <Form06 state={state} dispatch={dispatch} />}
      {state.nForm === 6 && (
        <>
          <SubirFotos
            dispatch={dispatch}
            state={state}
            files={files}
            imgBase64Data={imgBase64Data}
            setFiles={setFiles}
            setImgBase64Data={setImgBase64Data}
          />
          {/* {!user.esReto && ( */}
            <Tr4inerContainedButton
              variant="contained"
              style={{
                fontWeight: 'bold',
                textTransform: 'inherit',
                margin: '1rem 0',
              }}
              disabled={disabledButton()}
              onClick={continuar}
            >
              Enviar
            </Tr4inerContainedButton>
          {/* )} */}
        </>
      )}
    </div>
  );
};

export default MainForm;
